module.exports = __webpack_public_path__ + "static/tab01-2adbf88cd758637352dc75983651b7b5.png";